import React from "react";

type NumberPadProps = {
  onChange: (row: number, col: number, value: number | null) => void;
  onMultiNote?: (num: number, cells: { row: number; col: number }[]) => void;
  selectedCells: { row: number; col: number }[];
  board: import('../utils/sudokuGenerator').CellData[][];
  onPencilClick?: () => void;
  pencilMode?: boolean;
};

const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9];


const NumberPad: React.FC<NumberPadProps> = ({ onChange, onMultiNote, selectedCells, board, onPencilClick, pencilMode }) => {

  const handleNumberClick = (num: number) => {
    if (selectedCells.length > 1 && onMultiNote) {
      onMultiNote(num, selectedCells);
    } else if (selectedCells.length === 1) {
      const { row, col } = selectedCells[0];
      if (board[row][col].isInitial) return;
      onChange(row, col, num);
    }
  };

  const numberCounts = new Array(10).fill(0);
  for (let r = 0; r < 9; r++) {
    for (let c = 0; c < 9; c++) {
      const v = board[r][c].value;
      if (v && v >= 1 && v <= 9) numberCounts[v]++;
    }
  }

  return (
    <div className="numberpad-root" style={{ display: "flex", justifyContent: "space-between", width: '100%', gap: '0.2rem' }}>
      {numbers.map((num) => {
        const isFilled = numberCounts[num] >= 9;
        return (
          <button
            key={num}
            onMouseDown={e => e.preventDefault()}
            onClick={() => handleNumberClick(num)}
            style={{
              flex: 1,
              height: '3.5rem',
              minHeight: '2.5rem',
              fontSize: 'var(--sudoku-number-font-size)',
              fontWeight: 'bold',
              cursor: isFilled ? 'not-allowed' : 'pointer',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              background: isFilled ? 'var(--numberpad-filled-bg)' : 'var(--button-bg)',
              color: isFilled ? 'var(--numberpad-filled-color)' : 'var(--text-color)',
              opacity: isFilled ? 0.6 : 1,
            }}
            aria-label={`Number ${num}`}
          >
            {num}
          </button>
        );
      })}
      <button
        onClick={onPencilClick}
        style={{
          flex: 1,
          height: '3.5rem',
          minHeight: '2.5rem',
          fontSize: 'calc(var(--sudoku-number-font-size) * 0.85)',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: "pointer",
          background: pencilMode ? 'var(--button-selected-bg)' : 'var(--button-bg)',
          // border: pencilMode ? '2px solid var(--button-bg)' : '',
        }}
        aria-label="Pencil (notes)"
        title="Pencil (notes)"
      >
        ✏️
      </button>
    </div>
  );
};

export default NumberPad;
